import {gtmEvent, segment} from './helpers'

export const viewedAppointmentTypeModule = (showroom) =>
  segment('Viewed Appointment Type Module', {
    showroom,
  })

export const selectedAppointmentType = (appointmentType, showroom) =>
  segment('Selected Appointment Type', {
    appointmentType,
    showroom,
  })

export const viewedShowroomCalendar = (
  appointmentType,
  daysToEvent,
  daysToFirstAvailable,
  totalOpenDays,
  showroom,
) =>
  segment('Viewed Showroom Calendar', {
    appointmentType,
    daysToEvent,
    daysToFirstAvailable,
    totalOpenDays,
    showroom,
  })

export const selectedAppointmentDateAndTime = (
  appointmentType,
  daysToAppointment,
  daysToEvent,
  showroom,
) =>
  segment('Selected Appointment Date/Time', {
    appointmentType,
    daysToAppointment,
    daysToEvent,
    showroom,
  })

export const clickedOnCalendarDay = (showroom, numAppointmentsAvailable) =>
  segment('Clicked on Calendar Day', {
    showroom,
    numAppointmentsAvailable,
  })

export const submittedAppointmentForm = (appointmentType, daysToAppointment, daysToEvent) => {
  segment('Submitted Appointment Form', {
    appointmentType,
    daysToAppointment,
    daysToEvent,
  })
  gtmEvent('appointmentFormSubmit')
}

export const blockedAppointmentFlow = (error) =>
  segment('Blocked Appointment Flow', {
    error,
  })
